import { useEffect, useRef } from 'react';
import { sprinkles } from '@design-system/sprinkles.css';
import { useState } from 'react';
import { SelectThumbnailOnUpload } from './SelectThumbnailOnUpload';
import { EditName } from './EditName';
import { Button } from '@design-system/components/button/button';
import { UploadVideoVM } from '../../view-models/uploadVideo.viewModel';
import { UploadFile } from '../../models/uploadVideo.model';
import { getFileNameWihoutExtension } from '../../helpers';

const mapValuesToPayload = ({
  initialName,
  newName,
  extension,
  timestamp,
  index,
}: {
  initialName: string;
  newName: string;
  extension?: string;
  timestamp: number;
  index: number;
}) => {
  const newNameWithExtension = extension ? `${newName}.${extension}` : newName;
  return {
    name:
      initialName !== newNameWithExtension ? newNameWithExtension : undefined,
    timestamp: timestamp > 0 ? timestamp : undefined,
    index,
  };
};

export const ListEditItem = ({
  item,
  dispatch,
  index,
}: {
  item: UploadFile;
  index: number;
  dispatch: UploadVideoVM['dispatch'];
}) => {
  const [newName, setNewName] = useState(
    getFileNameWihoutExtension(item.file.name),
  );
  const [newTimestamp, setNewTimestamp] = useState(0);
  const [error, setError] = useState<string | undefined>();
  const editItemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const cancelEdit = function (event) {
      if (editItemRef?.current && !editItemRef.current.contains(event.target)) {
        dispatch('cancelFileEdit');
      }
    };
    document.addEventListener('click', cancelEdit);

    return () => {
      document.removeEventListener('click', cancelEdit);
    };
  }, []);

  const save = () => {
    if (!newName) {
      setError('Video title cannot be left empty');
      return;
    }
    const extension = item.file.name.split('.').pop();
    dispatch(
      'saveFileUpdate',
      mapValuesToPayload({
        initialName: item.file.name,
        newName,
        extension,
        timestamp: newTimestamp,
        index,
      }),
    );
  };

  return (
    <div
      className={sprinkles({
        bg: 'N-10',
        p: 'l',
        borderRadius: 'm',
        display: 'flex',
        flexDirection: 'column',
        gap: 'm',
      })}
      ref={editItemRef}
    >
      <div
        className={sprinkles({
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        })}
      >
        <EditName
          error={error}
          setError={setError}
          name={newName}
          setNewName={(value) => setNewName(value)}
          reset={() => setNewName(getFileNameWihoutExtension(item.file.name))}
        />
        <Button variant="text" onClick={save}>
          Save
        </Button>
      </div>
      <SelectThumbnailOnUpload
        videoSrc={item.videoSrc}
        onChange={(value) => setNewTimestamp(value)}
        onRestore={() => null}
      />
    </div>
  );
};
